import { Fragment } from 'react'
import classNames from 'classnames'

import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowActions,
  TableRowContextActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../Table'

import { renderCell } from './IdwellToIdwellRequestTableRow.utils'

import * as styles from './IdwellToIdwellRequestTableRow.module.css'

function IdwellToIdwellRequestTableRow({
  Actions = TableRowActions,
  actionLeft,
  actionsColumnWidth,
  availableSections,
  className,
  columns,
  context,
  emptyColumnSize,
  extra,
  focusedRow,
  getActions,
  hideCheckbox,
  isResizing,
  isSelected,
  isShort,
  item,
  outboundUuid,
  qaName,
  resizingColumn,
  scrollRef,
  showCellBorder,
  statuses,
  onClickFileTag,
  ...restProps
}) {
  const {
    handleCallAction,
    handleClick,
    handleMouseDown,
    handleMouseEnter,
    handleMouseLeave,
    handleSelect,
  } = useTableRowActions({ item, ...restProps })

  const rowClass = useTableRowModClassName({
    className: classNames(className, styles.IdwellToIdwellRequestTableRow),
    isSelected,
  })

  const qaProps = getTableRowQaProps(qaName)

  return (
    <div
      {...qaProps}
      className={rowClass}
      key={item.id}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {Actions ? (
        <Actions
          disabled={hideCheckbox}
          selected={isSelected}
          width={actionsColumnWidth}
          onChange={handleSelect}
        />
      ) : null}
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({
            availableSections,
            context,
            extra,
            isActive: column.name === resizingColumn,
            isResizing,
            isShort,
            item,
            name: column.name,
            outboundUuid,
            scrollRef,
            showCellBorder,
            statuses,
            width: column.width,
            onClickFileTag,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
      {getActions?.(item)?.length > 0 ? (
        <TableRowContextActions
          actionLeft={actionLeft}
          focusedRow={focusedRow}
          getActions={getActions}
          item={item}
          onCallAction={handleCallAction}
        />
      ) : null}
    </div>
  )
}

export default IdwellToIdwellRequestTableRow
